import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { choice_array, choices, formArrayItem } from '../preview-forms.interface';
import { getUploadsBaseURL } from 'src/app/app.url';
import { resolveMediaUrl } from 'src/app/shareds/utils/media-url.util';
import { isChoiceFull } from 'src/app/shareds/utils/quota.util';

@Component({
    selector: 'app-form-multiple',
    templateUrl: './form-multiple.component.html',
    styleUrls: ['./form-multiple.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FormMultipleComponent {
  value: string[] = [];
  /** ข้อความที่ผู้ตอบพิมพ์ในตัวเลือก "อื่น ๆ (ระบุ)" — เก็บแยกตาม question_choice_id */
  otherText: { [choiceId: string]: string } = {};
  form!: formArrayItem;
  loading: boolean = false;
  @Input('model') set item(v: formArrayItem) {
    this.form = v;
    if (this.form?.choices_value) this.setValue();

  }

  @Output('update') update = new EventEmitter()
  @Output('valid') valid = new EventEmitter()

  trackByIndex(index: number): number { return index; }

  private uploadsBaseURL: string = getUploadsBaseURL();
  /** แปลง path รูปภาพประกอบตัวเลือก (คำถามแบบเทียบรูป) เป็น URL ที่โหลดได้จริง */
  resolveChoiceMediaUrl(path?: string | null): string | null {
    return resolveMediaUrl(this.uploadsBaseURL, path);
  }

  setValue() {
    this.value = [];
    this.otherText = {};
    this.form?.choices_value?.forEach((f: choice_array) => {
      this.value.push(f.question_choice_id)
      if (f.choice_value != null) this.otherText[f.question_choice_id] = f.choice_value
    })
  }

  /** ตัวเลือกนี้เป็น "อื่น ๆ (ระบุ)" หรือไม่ */
  isOther(choiceId: string): boolean {
    return (this.form?.choices || []).some((c: choices) => c.question_choice_id === choiceId && c.is_other_option === true)
  }

  private emit() {
    const payload: choice_array[] = this.value.map((id) => {
      const item: choice_array = { question_choice_id: id }
      if (this.isOther(id)) item.choice_value = this.otherText[id] ?? ""
      return item
    })
    this.update.emit(payload)
    this.valid.emit(this.value.length ? false : true)
  }

  updateValue() {
    if (this.form?.view) return
    this.emit()
  }

  toggleChoice(sm: any) {
    if (this.form?.view) return
    const id = sm.question_choice_id
    // สร้าง array ใหม่เสมอ (ห้าม push/splice ในที่เดิม) — p-checkbox เป็น OnPush เช็คแค่ reference,
    // mutate ในที่เดิมแล้ว UI จะไม่อัปเดตแม้ค่าจริงจะถูกต้องก็ตาม
    if (this.value.includes(id)) {
      this.value = this.value.filter(v => v !== id)
      delete this.otherText[id]
    } else {
      // เต็มแล้ว = เลือกเพิ่มไม่ได้ (ติ๊กออกยังทำได้ปกติ) — บังคับจริงอยู่ที่ backend เสมอ
      if (this.isChoiceFull(sm)) return
      this.value = [...this.value, id]
    }
    this.updateValue()
  }

  isChoiceFull(sm: any): boolean {
    return isChoiceFull(sm) && !this.value.includes(sm.question_choice_id)
  }

  onOtherText() {
    if (this.form?.view) return
    this.emit()
  }

  updateValiDate(e: any) {
    this.valid.emit(e)
  }
}
